"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORIGIN_CERTIFICATE = 1;
exports.MANAGEMENT_KEY = 1;
exports.ACTION_KEY = 2;
exports.CLAIM_SIGNER_KEY = 3;
exports.ENERGY_METER_KEY = 901;
exports.ECDSA_TYPE = 1;
exports.RSA_TYPE = 2;
exports.PERSONAL_DATA = 1;
exports.ORGANIZATION_DATA = 2;
exports.ASSET_DATA = 3;
exports.ENERGY_METERDATA_REGISTRY_TOPIC = 901;
exports.ENERGY_CERTIFICATE_REGISTRY_TOPIC = 902;
exports.ENERGY_METER_TOPIC = 903;
exports.ENERGY_AGREEMENT_TOPIC = 991;
exports.Call = 0;
exports.DelegateCall = 1;
exports.Create = 2;
exports.ECDSA_SCHEME = 1;
exports.RSA_SCHEME = 2;
exports.CONTRACT_SCHEME = 3;
exports.CONSUMER_ASSET_TYPE = 1;
exports.PRODUCER_ASSET_TYPE = 2;
exports.PROSUMER_ASSET_TYPE = 3;
exports.PRODUCT_ASSET_TYPE = 4;
exports.BIOMASS = 'biomass';
exports.HYDRO = 'hydro';
exports.SOLAR = 'solar';
exports.WIND = 'wind';
exports.CUSTOM01 = 'custom01';
exports.ENERGY_TYPES = [
    exports.BIOMASS,
    exports.HYDRO,
    exports.SOLAR,
    exports.WIND,
    exports.CUSTOM01
];
exports.DAILY = 1440;
exports.HOURLY = 60;
exports.QUARTERLY = 15;
exports.LOGIN_SIGNATURE_PREFIX = "Proceed if you intent to login.\n\nThe following random characters are used to provide full security:\n\n";
exports.LINK_ACCOUNT_SIGNATURE_PREFIX = "Proceed if you intent to link you account.\n\nThe following random characters are used to provide full security:\n\n";
